module.exports = __webpack_public_path__ + "img/logo_biom.33ae3dc0.jpg";